/**
 * This module provides functions in relation to calling API routes on the backend server and processing the incoming
 * responses. The functions in this module refer to the API endpoint ApiEndPoints.TIME_SERIES_ROW.
 * @module
 */

import {ApiEndPoints, HttpMethods} from "../base/Settings";
import type {FetchRequest, TimeSeriesRowInput, TimeSeriesRow, UUID} from "../base/ui_general/GeneralInterfaces";


/**
 * Creates a FetchRequest object populated with the parameters necessary for triggering the creation of a new
 * time_series_row on the server. Only name, description and time_series_row type need to be specified for this purpose.
 * @param time_series_rowInput An object of type TimeSeriesRowInput containing the input data for creating the time_series_row.
 * @returns A FetchRequest object containing the generated fetch request.*/
export function getRequest_create_time_series_row(time_series_rowInput: TimeSeriesRowInput): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.TIME_SERIES_ROW,
        method: HttpMethods.POST,
        query_parameters: {},
        body: time_series_rowInput,
    }
}


/**
 * Creates a FetchRequest object populated with the parameters necessary for updating an existing
 * time_series_row on the server.
 * @param time_series_row An object of type TimeSeriesRow containing the updated time_series_row data.
 * @returns A FetchRequest object containing the generated fetch request.
 */
export function getRequest_update_time_series_row(time_series_row: TimeSeriesRow): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.TIME_SERIES_ROW,
        method: HttpMethods.PUT,
        query_parameters: {},
        body: time_series_row,
    };
}


/**
 * Creates a FetchRequest object populated with the parameters necessary for triggering the query of time_series_rows
 * on the server.
 * @param time_series_id Optional. The UUID of the time_series to query for.
 * @returns A FetchRequest object containing the generated fetch request.*/
export function getRequest_get_all_time_series_rows(time_series_id: UUID): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.TIME_SERIES_ROW,
        method: HttpMethods.GET,
        query_parameters: { time_series_id: time_series_id },
    }
}


/**
 * Creates a FetchRequest object populated with the parameters necessary for deleting an existing
 * time_series_row on the server.
 * @param time_series_row_id The UUID of the time_series_row to delete.
 * @returns A FetchRequest object containing the generated fetch request.
 */
export function getRequest_delete_time_series_row(time_series_row_id: UUID): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.TIME_SERIES_ROW,
        method: HttpMethods.DELETE,
        query_parameters: { time_series_row_id : time_series_row_id },
    };
}
